import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HttpHelper } from '@umss/shared/utils';
import { Observable } from 'rxjs';
import {
  ContractorCitationDetailDto,
  ContractorCitationListDto,
  ContractorCitationSearchDto,
  CreateContractorCitationDto,
  PagedResultDto,
  UpdateContractorCitationDto
} from '../../models';

@Injectable({ providedIn: 'root' })
export class ContractorCitationService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = '/api/citations';

  getAll(
    parameters?: ContractorCitationSearchDto
  ): Observable<PagedResultDto<ContractorCitationListDto>> {
    const params = HttpHelper.toHttpParams(parameters ?? {});
    return this.http.get<PagedResultDto<ContractorCitationListDto>>(
      this.baseUrl,
      { params }
    );
  }

  getCount(contractorId: string): Observable<{ count: number }> {
    const params = HttpHelper.toHttpParams({ contractorId });
    return this.http.get<{ count: number }>(`${this.baseUrl}/count`, {
      params
    });
  }

  get(id: string): Observable<ContractorCitationDetailDto> {
    return this.http.get<ContractorCitationDetailDto>(`${this.baseUrl}/${id}`);
  }

  create(
    requestBody: CreateContractorCitationDto
  ): Observable<ContractorCitationDetailDto> {
    return this.http.post<ContractorCitationDetailDto>(
      this.baseUrl,
      requestBody
    );
  }

  update(
    id: string,
    requestBody: UpdateContractorCitationDto
  ): Observable<ContractorCitationDetailDto> {
    return this.http.put<ContractorCitationDetailDto>(
      `${this.baseUrl}/${id}`,
      requestBody
    );
  }

  resolve(id: string): Observable<ContractorCitationDetailDto> {
    return this.http.patch<ContractorCitationDetailDto>(
      `${this.baseUrl}/${id}/resolve`,
      {}
    );
  }
}
